import { MenuItem } from '@mui/material';

import styled from 'styled-components';

import { colors } from 'theme/colors';

export const StyledMenuItem = styled(MenuItem)`
  color: ${colors.legacy.grey[200]};
  font-size: 1.3rem;
  line-height: 2rem;
`;
